export const modalTextCopy = {
  canada: {
    top: 'Easily request an accredited criminal background check that meets the rigorous standards of the national government — no paperwork, no delays.',
    bulletPoints: [
      '100% online process',
      'Fast turnaround times, with many results returned in hours',
      'Accurate, up-to-date information from verified official sources'
    ],
    bottom:
      'Trusted by employers across North America, our checks comply with national and regional regulations and are powered by advanced automation and deep industry expertise — and now you can request them directly.'
  },
  australia: {
    top: 'Easily request an accredited criminal history check that meet the rigorous standards set by the Australian Criminal Intelligence Commission (ACIC) — no paperwork, no delays.',
    bulletPoints: [
      '100% online process',
      'Fast results, delivered electronically',
      'Accurate data from official Australian authorities'
    ],
    bottom:
      'Our checks are trusted by employers, government, and licensing bodies Australia-wide — and now you can request them directly.'
  }
};
